import { h } from 'preact';
import styled from 'react-emotion';
import { withContext } from '../../../common/context';
import { getObjectByPrefix } from '../../../utils/object';
import { getRgbaColor } from '../../../utils/color';

export const Lens = styled('div')`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  border-radius: ${props => props.radius}px;
  inset: 50%;
  opacity: 0;
  position: absolute;
  background-color: ${props => getRgbaColor(props.color, props.opacity)};
  ${props => (props.shadow ? `box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);` : '')};
  ${props =>
    props.borderWidth > 0 ? `border: ${props.borderWidth}px solid ${props.borderColor};` : ''};
`;

const ZoomLens = props => {
  const config = props.context.config;
  const lensProps = getObjectByPrefix('lens', config.selectZoomProps());

  const lensStyles = props.show
    ? {
        opacity: 1,
        translate: `calc(-50% + ${props.left}px) calc(-50% + ${props.top}px)`
      }
    : {};

  return (
    <Lens
      data-test="zoom-lens"
      width={props.width}
      height={props.height}
      radius={props.radius}
      style={lensStyles}
      {...lensProps}
    />
  );
};

export default withContext(ZoomLens);
